import React from "react";
import search from "../../images/icons/search.png";
import "../CustomSearchBar/CustomSearchBar.css";

const CustomSearchBar = ({ value, setValue, onSearch }) => {

  const handleChange = (e) => {
    const searchValue = e.target.value;
    setValue(searchValue);

    if (searchValue === "") {
      onSearch("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(value);
    }
  };

  return (
    <div className="search-container">
      <input
        type="text"
        className="searchInput"
        placeholder="Search"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />

      <button className="btnSearch" onClick={() => onSearch(value)}>
        <img src={search} className="imgIcon" alt="search" />
      </button>
    </div>
  );
};

export default CustomSearchBar;